import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, unref as _unref, toDisplayString as _toDisplayString, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-599d5594"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "setting-panel version-control" }
const _hoisted_2 = { class: "section-content" }
const _hoisted_3 = { class: "setting-box autoupgrade-setting" }
const _hoisted_4 = { class: "setting-title" }
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h4", null, "版本信息", -1))
const _hoisted_6 = { class: "setting-btn" }

import {onMounted, onUnmounted, reactive} from 'vue'
import Button from '@remote/components/Button.vue'
import { getHeziClientVersion, checkUpdate, HeziPCClientMessage} from '@remote/utils/hezi-pc-client'

type TMessage = {status: string; msg: string; loading:boolean; disabled:boolean}

export default /*#__PURE__*/_defineComponent({
  setup(__props) {

const updateEvent = 'CHECK_UPDATE_MESSAGE'
const updateMessage = reactive<TMessage>({
  status: 'StartCheck', 
  msg: '迅雷盒子客户端会在启动后自动检测更新', 
  loading: false,
  disabled: false,
})

const onCheckUpdate = () => {
  checkUpdate()
  updateMessage.loading = true
}

const onUpdateMessage = (event:string, message: TMessage) => {
  console.log('onUpdateMessage', event)
  if (event === updateEvent) {
    switch(message.status) {
      case 'CheckErr':
      case 'NoUpdate':
        updateMessage.loading = false
        updateMessage.disabled = false
        break
      case 'CheckUpdateIng':
      case 'NewVersion':
      case 'UpdateDownLoad':
        break
      case 'UpdateEnd':
        updateMessage.loading = false
        updateMessage.disabled = true
        break
    }
    updateMessage.status = message.status
    updateMessage.msg = message.msg
  }
}

onMounted(() => {
  HeziPCClientMessage.addEventListener('message', onUpdateMessage)
})

onUnmounted(() => {
  HeziPCClientMessage.removeEventListener('message', onUpdateMessage)
})


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, [
          _hoisted_5,
          _createElementVNode("p", null, _toDisplayString(_unref(updateMessage).msg), 1)
        ]),
        _createElementVNode("div", null, [
          _createElementVNode("div", null, "迅雷盒子 " + _toDisplayString(_unref(getHeziClientVersion)()), 1),
          _createElementVNode("div", _hoisted_6, [
            _createVNode(Button, {
              text: "检查更新",
              onClick: onCheckUpdate,
              loading: _unref(updateMessage).loading,
              disabled: _unref(updateMessage).disabled
            }, null, 8, ["loading", "disabled"])
          ])
        ])
      ])
    ])
  ]))
}
}

})